import {Injectable, Signal, signal} from '@angular/core';

export interface SpinnerState {
  show: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private _spinnerState = signal<SpinnerState>({show: true});
  public spinnerState: Signal<SpinnerState> = this._spinnerState;

  public show(): void {
    this._spinnerState.set({show: true});
  }

  public hide(): void {
    this._spinnerState.set({show: false});
  }
}
